<div
	class="p-4"
	appHelpContext="protocols.viewer">
	<div
		class="flex flex-row"
		style="margin-bottom: 8px">
		@if (navigationStack.size() > 0) {
			<button
				mat-raised-button
				(click)="back()">
				<mat-icon>arrow_back</mat-icon>
			</button>
		}
		<div class="viewer-actions">
			@if (canUseNotes) {
				<button
					mat-raised-button
					[matTooltip]="'protocols.notes.viewer.tooltip' | translate"
					[matBadge]="notes.length"
					[matBadgeHidden]="notes.length === 0"
					matBadgeColor="warn"
					matBadgeSize="small"
					(click)="openNotes()">
					<mat-icon>sticky_note_2</mat-icon>
				</button>
			}
			<app-help-button context="protocols.viewer" />
		</div>
	</div>

	<div class="iframe-wrapper">
		@if (isLoading) {
			<div class="shimmer-overlay">
				<div class="shimmer shimmer-title"></div>
				<div class="shimmer shimmer-line w-3/4"></div>
				<div class="shimmer shimmer-line w-full"></div>
				<div class="shimmer shimmer-line w-5/6"></div>
				<div class="shimmer shimmer-line w-full"></div>
				<div class="shimmer shimmer-line w-2/3"></div>
				<div class="shimmer shimmer-block"></div>
				<div class="shimmer shimmer-line w-full"></div>
				<div class="shimmer shimmer-line w-4/5"></div>
				<div class="shimmer shimmer-line w-full"></div>
				<div class="shimmer shimmer-line w-3/5"></div>
			</div>
		}

		<iframe
			#iframeElement
			id="protocol-iframe"
			[srcdoc]="safeContent"
			sandbox="allow-scripts allow-same-origin allow-modals"></iframe>
	</div>

	<app-menu-fab
		class="menu-mat-fab"
		(itemClickChange)="fabMenuCallback($event)"
		[fabButtons]="fabItems" />
</div>
